module.exports = __webpack_public_path__ + "img/Layer-5.43e5c5b8.webp";